import lscache from 'lscache';

export default [
  {
    path: '/projects/:projectId(\\d+)/finance',
    component: () => import('./RouteProjectsFinance.vue'),
    children: [
      {
        path: '',
        redirect() {
          // Default redirect to last section visited or budgets
          const lastSection = lscache.get('twProjects-last-finance-section');
          return ['budgets', 'rates'].includes(lastSection) ? lastSection : 'budgets';
        },
      },
      {
        path: 'budgets',
        component: () => import('./RouteProjectsFinanceBudgets.vue'),
        beforeEnter(to, from, next) {
          lscache.set('twProjects-last-finance-section', 'budgets');
          next();
        },
      },
      {
        path: 'rates',
        component: () => import('./RouteProjectsFinanceRates.vue'),
        beforeEnter(to, from, next) {
          lscache.set('twProjects-last-finance-section', 'rates');
          next();
        },
      },
      {
        path: '*',
        redirect: '.',
      },
    ],
  },
  // Legacy billing path — billing/invoices now lives in the new finance experience
  {
    path: '/projects/:projectId(\\d+)/billing',
    redirect(to) {
      return `/projects/${to.params.projectId}/finance`;
    },
    children: [
      {
        path: '*',
        redirect: '.',
      },
    ],
  },
];
